import { useAuthSession } from '@/common/hooks/use-auth-session.hook';

export function useSession() {
  const { data, status, logout, refresh } = useAuthSession();
  return { data: data as any, status, logout, refresh } as const;
}
